import { connect } from 'react-redux'
import get from 'lodash/get'

import { Listings } from '../components/ListingsPage'
import { listingsFilterCall } from '../actions/listings'
import { setSessionExpired } from '../actions/flags'
import { setCurrentMobileFilter } from '../actions/uiToggles'
import {
  setInitialFilterInfo,
  updateAirlineFiltersReq,
  updateStopsFiltersReq,
  updateAirlineFiltersUI,
  updateStopsFiltersUI,
  updateAirportsFiltersUI,
  updateAirportsFiltersReq,
  updateExactDateFiltersUI,
  updateExactDateFiltersReq,
  updateTimeFilters,
  resetTimeFilters,
  updateAttributesFiltersUI,
} from '../actions/filters'

const mapStateToProps = state => ({
  filtersAreReady: !!get(state, 'filterInfo.defaults', null),
  airlines: get(state, 'airlines'),
  cacheListings: get(state, 'cacheListings', {}),
  enableAds:
    state.pclnBootstrapData?.features?.whiteLabel?.adsEnabled &&
    get(state, 'uiToggles.displayAds', true),
  fetchedInitialListings: state.fetchedInitialListings,
  currentMobileFilter: get(state, 'uiToggles.currentMobileFilter', ''),
  listingsIsLoading: get(state, 'listingsIsLoading', false),
  pclnBootstrapData: state.pclnBootstrapData,
  SETI: get(state, 'pclnBootstrapData.requestLocals.seti', []),
  showLoadingOverlay:
    !get(state, 'uiToggles.loadingOverlay') &&
    state.listingsIsLoading &&
    !state.listingsHasErrored,
  expiredSessionTimestamp: get(state, 'listings.expiredSessionTimestamp'),
  voidWindowInfo: get(state, 'listings.voidWindowInfo'),
  hasExpressDeal: get(state, 'flags.hasExpressDeal'),
  isAirCanada: get(state, 'listings.isAirCanada'),
  cheapestPrice: get(
    state,
    'listings.response.rawResponse.filteredTripSummary.minTotalFareWithTaxesAndFees'
  ),
  altDeals: get(state, 'listings.altDeals'),

  // filters info
  airlinesFilter: state.airlinesFilter || [],
  altDatesFilter: state.altDatesFilter,
  stopsFilter: state.stopsFilter || [],
  airportsFilter: state.airportsFilter || [],
  timeFilter: state.timeFilter || [],
  filterDefaults: state.filterInfo.defaults || {},
  filterValues: state.filterInfo.values || {},
  activeTabId: state.activeTabId || 1,
  attributesFilter: state.attributesFilter || [],
})

const mapDispatchToProps = dispatch => ({
  listingsFilterCall: (pclnBootstrapData, displayType, filters) => {
    dispatch(listingsFilterCall(pclnBootstrapData, displayType, filters))
  },
  setSessionExpired: bool => dispatch(setSessionExpired(bool)),
  setCurrentMobileFilter: (filterName = '') =>
    dispatch(setCurrentMobileFilter(filterName)),
  setInitialFilterInfo: (filterDefaults, isSBS, activeTabId) => {
    filterDefaults.NUM_OF_STOPS = filterDefaults?.NUM_OF_STOPS?.map(stop => ({
      ...stop,
      checked: false,
    }))

    return dispatch(
      setInitialFilterInfo(filterDefaults, {
        isSBS,
        activeTabId,
        isManual: true,
      })
    )
  },
  updateStopsFiltersUI: (payload, meta) =>
    dispatch(updateStopsFiltersUI(payload, meta)),
  updateStopsFiltersReq: (payload, meta, sbsParams) =>
    dispatch(updateStopsFiltersReq(payload, meta, sbsParams)),
  updateAirlineFiltersUI: (payload, meta) =>
    dispatch(updateAirlineFiltersUI(payload, meta)),
  updateAirlineFiltersReq: (payload, meta, airlines, sbsParams) =>
    dispatch(updateAirlineFiltersReq(payload, meta, airlines, sbsParams)),
  updateAirportsFiltersUI: (payload, meta, entity) =>
    dispatch(updateAirportsFiltersUI(payload, meta, entity)),
  updateAirportsFiltersReq: (payload, meta, entity, sbsParams) =>
    dispatch(updateAirportsFiltersReq(payload, meta, entity, sbsParams)),
  updateExactDateFiltersUI: (payload, entity) =>
    dispatch(updateExactDateFiltersUI(payload, entity)),
  updateExactDateFiltersReq: (payload, entity) =>
    dispatch(updateExactDateFiltersReq(payload, entity)),
  updateTimeFilter: (payload, entity, sliceRefId, sbsParams) =>
    dispatch(updateTimeFilters(payload, entity, sliceRefId, sbsParams)),
  resetTimeFilter: entity => dispatch(resetTimeFilters(entity)),
  updateAttributesFiltersUI: ({ payload, meta, entity }) =>
    dispatch(updateAttributesFiltersUI({ payload, meta, entity })),
})

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    setInitialFilter: () =>
      Promise.all([
        dispatchProps.setInitialFilterInfo(
          stateProps.filterDefaults,
          !!stateProps.pclnBootstrapData.isRoundTrip,
          stateProps.activeTabId
        ),
        dispatchProps.listingsFilterCall(
          stateProps.pclnBootstrapData,
          'filter'
        ),
      ]),
    resetTimeFilters: entity => {
      Promise.all([
        dispatchProps.resetTimeFilter(entity),
        dispatchProps.listingsFilterCall(stateProps.pclnBootstrapData, 'TIME'),
      ])
    },
    updateTimeFilters: (paylaod, entity, sliceRefId) => {
      Promise.all([
        dispatchProps.updateTimeFilter(paylaod, entity, sliceRefId, {
          isSBS: !!stateProps.pclnBootstrapData.isRoundTrip,
          activeTabId: stateProps.activeTabId,
        }),
        dispatchProps.listingsFilterCall(
          stateProps.pclnBootstrapData,
          'filter'
        ),
      ])
    },
  }
}

const ListingsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(Listings)

export { ListingsContainer }
